/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Configuration for banned words guardrail
 */
export type BanWordsConfig = {
  /**
   * List of banned words or phrases
   */
  words?: Array<string> | undefined;
  /**
   * The message to return when this guardrail is triggered
   */
  rejectionMessage?: string | undefined;
};

/** @internal */
export const BanWordsConfig$inboundSchema: z.ZodType<
  BanWordsConfig,
  z.ZodTypeDef,
  unknown
> = z.object({
  words: z.array(z.string()).optional(),
  rejection_message: z.string().default(
    "I'm sorry, but I can't process this request as it contains content that isn't allowed. Please rephrase your message.",
  ),
}).transform((v) => {
  return remap$(v, {
    "rejection_message": "rejectionMessage",
  });
});
/** @internal */
export type BanWordsConfig$Outbound = {
  words?: Array<string> | undefined;
  rejection_message: string;
};

/** @internal */
export const BanWordsConfig$outboundSchema: z.ZodType<
  BanWordsConfig$Outbound,
  z.ZodTypeDef,
  BanWordsConfig
> = z.object({
  words: z.array(z.string()).optional(),
  rejectionMessage: z.string().default(
    "I'm sorry, but I can't process this request as it contains content that isn't allowed. Please rephrase your message.",
  ),
}).transform((v) => {
  return remap$(v, {
    rejectionMessage: "rejection_message",
  });
});

export function banWordsConfigToJSON(banWordsConfig: BanWordsConfig): string {
  return JSON.stringify(BanWordsConfig$outboundSchema.parse(banWordsConfig));
}
export function banWordsConfigFromJSON(
  jsonString: string,
): SafeParseResult<BanWordsConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => BanWordsConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'BanWordsConfig' from JSON`,
  );
}
